export const filterEmptyStrings = (text: string) => {
  return text
    .split(' ')
    .filter(s => s) // filter empty strings
    .join(' ')
}
